import { format } from 'date-fns';
import apiClient from './apiClient';
import { Shift, ShiftQueryParams, ShiftInput, StaffAvailabilityResponse, ShiftTargetUser } from '../types/shift';

/**
 * シフト一覧を取得する
 */
export const getShifts = async (params: ShiftQueryParams = {}): Promise<{ shifts: Shift[], total: number }> => {
  try {
    const response = await apiClient.get('/shifts', { params });
    return response.data; // オブジェクト全体を返すように変更
  } catch (error) {
    console.error('シフト取得エラー:', error);
    throw error;
  }
};

/**
 * シフトを作成する
 */
export const createShift = async (shiftData: ShiftInput): Promise<Shift> => {
  try {
    const response = await apiClient.post('/shifts', shiftData);
    return response.data;
  } catch (error) {
    console.error('シフト作成エラー:', error);
    throw error;
  }
};

/**
 * シフトを更新する
 */
export const updateShift = async (shiftId: string, shiftData: Partial<ShiftInput>): Promise<Shift> => {
  try {
    const response = await apiClient.put(`/shifts/${shiftId}`, shiftData);
    return response.data;
  } catch (error) {
    console.error('シフト更新エラー:', error);
    throw error;
  }
};

/**
 * シフトを削除する
 */
export const deleteShift = async (shiftId: string): Promise<void> => {
  try {
    await apiClient.delete(`/shifts/${shiftId}`);
  } catch (error) {
    console.error('シフト削除エラー:', error);
    throw error;
  }
};

/**
 * スタッフの空き状況を取得する
 * 現在の日付を使用
 */
export const getStaffAvailability = async (date?: string): Promise<StaffAvailabilityResponse> => {
  try {
    // 日付パラメータが指定されていない場合、現在の日付を使用
    const today = date || format(new Date(), 'yyyy-MM-dd');
    
    const now = new Date();
    const time = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
    
    console.log(`シフト情報APIを呼び出し: /shifts/availability?date=${today}&time=${time}`);
    
    const response = await apiClient.get('/shifts/availability', {
      params: { 
        date: today,
        time // 時間パラメータを追加
      }
    });
    
    console.log('シフト情報API成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('シフト情報取得APIエラー:', error);
    
    // API呼び出しが失敗した場合（404やバックエンドが未実装）、モックデータを返す
    console.warn('シフト情報APIが失敗したため、モックデータを返します');
    
    // パラメータの日付または現在の日付を使用
    const today = date || format(new Date(), 'yyyy-MM-dd');
    
    // モックデータを生成
    const mockResponse: StaffAvailabilityResponse = {
      date: today,
      available_staff: [
        // 開発用のモックスタッフを準備
        { id: '1', name: '山田 太郎', role: 'cast', status: 'available', shifts: [] },
        { id: '2', name: '佐藤 次郎', role: 'cast', status: 'break', shifts: [] },
        { id: '3', name: '田中 三郎', role: 'cast', status: 'unavailable', shifts: [] },
        { id: '4', name: '鈴木 四郎', role: 'driver', status: 'available', shifts: [] },
        { id: '5', name: '伊藤 五郎', role: 'driver', status: 'unavailable', shifts: [] }
      ]
    };
    
    return mockResponse;
  }
};

/**
 * シフト管理の対象となるユーザーの一覧を取得する
 */
export const getShiftTargetUsers = async (): Promise<ShiftTargetUser[]> => {
  try {
    const response = await apiClient.get('/shifts/target-users');
    return response.data;
  } catch (error) {
    console.error('シフト対象ユーザー取得エラー:', error);
    throw error;
  }
};


/**
 * 未通知(notified=false)のシフト件数を取得する
 */
export const getPendingShiftCount = async (): Promise<number> => {
  try {
    const response = await apiClient.get('/shifts/pending-count');
    return response.data?.pending_count ?? 0;
  } catch (error) {
    console.error('未通知シフト件数の取得エラー:', error);
    return 0;
  }
};

/**
 * 未通知のシフトをまとめて管理者へLINE送信する
 */
export const notifyPendingShifts = async (): Promise<{ sent_count: number; message: string }> => {
  const response = await apiClient.post('/shifts/notify-pending', {});
  return response.data;
};
